import {useEffect, useRef} from 'react'

import {V2_FIELDS} from '../schema/contactSchema.js'

const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24
const PREFILL_WINDOW_DAYS = 14

const isWithinPrefillWindow = date => {
  const elapsed = Date.now() - new Date(date).getTime()

  return Number.isFinite(elapsed) && elapsed / MILLISECONDS_PER_DAY <= PREFILL_WINDOW_DAYS
}

export const useLastContactPrefill = ({domain, userData, applyPrefill}) => {
  const hasRestoredLastContact = useRef(false)

  useEffect(() => {
    if (hasRestoredLastContact.current || userData) {
      return
    }

    hasRestoredLastContact.current = true

    const restoreLastContact = async () => {
      const [error, lastContact] = await domain.get('get_last_contact_details_seller_use_case').execute()

      if (error || !lastContact) {
        return
      }

      applyPrefill({
        values: {
          [V2_FIELDS.NAME]: lastContact.name,
          [V2_FIELDS.EMAIL]: lastContact.email,
          [V2_FIELDS.PHONE]: lastContact.phone,
          [V2_FIELDS.ZIP_CODE]: lastContact.zipCode
        },
        areTermsAccepted: isWithinPrefillWindow(lastContact.date)
      })
    }

    restoreLastContact()
  }, [domain, userData, applyPrefill])
}

export default useLastContactPrefill
